import React from 'react';

import {
  Container, MessageContainer, Text,
} from './styles';

const ErrorWebsocket = () => (
  <Container>
    <MessageContainer>
      <Text>Something went wrong</Text>
      <Text>Please refresh the page. If the issue persists, contact support for assistance.</Text>
    </MessageContainer>
  </Container>
);

export default ErrorWebsocket;
